import styles from "./Placeholder.module.css";

export function Placeholder({ width = 48 }: { width?: number }) {
  return <div className={styles.placeholder} style={{ width }} />;
}
